import React, { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPenToSquare,
  faEllipsis,
  faSitemap,
  faPrint,
  faList,
  faTrash,
  faShare,
  faPlay,
  faFolderPlus,
  faFileArrowUp,
  faPaperPlane,
  faClipboardCheck,
  faPaste,
  faLock,
  faUserCheck,
  faKey,
  faCaretUp,
  faCaretDown,
  faSpinner,
  faFilePen
} from '@fortawesome/free-solid-svg-icons';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import Dropdown from 'react-bootstrap/Dropdown';
import assignedVia_1 from '../../../assets/images/assignedVia_1.png';
import assignedVia_2 from '../../../assets/images/assignedVia_2.png';
import assignedVia_3 from '../../../assets/images/assignedVia_3.png';
import assignedVia_4 from '../../../assets/images/assignedVia_4.png';
import { useAssignmentContext } from '../../assignments/context';
import {
  useGetAssignmentsByFilterMutation,
  useGetFiltersMutation
} from '../../../features/authentication/authApiSlice';
import OptionTileModal from '../pages/AssignmentsAndActivities/Components/modals/OptionTileModal';
import ViewCoTeachersModal from '../pages/AssignmentsAndActivities/Components/modals/ViewCoTeachersModal';
import DeleteMenuModal from './assignmentFloatingMenu/modals/DeleteMenuModal';
import {
  useExportXmlAssignmentsMutation,
  useGetCollaboratorCountMutation,
  useGetCoTeachersByAssignmentMutation
} from '../../../features/authentication/assignApiSlice';
import MoveMenuModal from './assignmentFloatingMenu/modals/MoveMenuModal';
import ShareMenuModal from './assignmentFloatingMenu/modals/ShareMenuModal';
import PublishMenuModal from './assignmentFloatingMenu/modals/PublishMenuModal';
import SubmitMenuModal from './assignmentFloatingMenu/modals/SubmitMenuModal';
import DuplicateMenuModal from './assignmentFloatingMenu/modals/DuplicateMenuModal';
import { useDashboardContext } from '../../dashboard/context';
import AssignMenuPreviewModal from './assignmentFloatingMenu/modals/AssignMenuPreviewModal';
import appConfig from '../../../app-config';
import { useSelector } from 'react-redux';
import { selectCurrentToken } from '../../../features/authentication/authSlice';
import CustomToast from '../../../components/Toast';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { useNavigate } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import Skeleton from 'react-loading-skeleton';
import SkeletonGrid from '../../../components/SkeletonLoader/SkeletonGrid';

const baseUrl = appConfig.apiBaseUrl;
const CurrentAssignmentsList = () => {
  const token = useSelector(selectCurrentToken);
  let assign = '';
  let assignText = '';
  let assignTooltip = '';
  let circlePathColor = '';
  const [exportAssignment] = useExportXmlAssignmentsMutation();
  const [getCollaborator] = useGetCollaboratorCountMutation();
  const [loadMoreData, setLoadMoreData] = useState([]);
  const [loadMegaDropDown, setLoadMegaDropDown] = useState([]);

  const selectedAssignment = useAssignmentContext();
  const [getAssignmentsByFilter] = useGetAssignmentsByFilterMutation();
  const [getFilters] = useGetFiltersMutation();
  const [getCoteachers] = useGetCoTeachersByAssignmentMutation();

  const [assignmentSortValue, setAssignmentSortValue] = useState(null);
  const [assignmentSortOrder, setAssignmentSortOrder] = useState(false);
  const [printingOptionsModal, setPrintingOptionsModal] = useState(false);
  const [deleteAssignmentsModal, setDeleteAssignmentsModal] = useState(false);
  const [moveAssignmentsModal, setMoveAssignmentsModal] = useState(false);
  const [publishAssignmentsModal, setPublishAssignmentsModal] = useState(false);
  const [submitAssignmentsModal, setSubmitAssignmentsModal] = useState(false);
  const [duplicateAssignmentsModal, setDuplicateAssignmentsModal] = useState(false);
  const [previewAssignmentModal, setPreviewAssignmentModal] = useState(false);
  const [viewCoTeachersModal, setViewCoTeachersModal] = useState(false);
  const [filters, setFilters] = useState([]);
  const [newCourseId, setNewCourseId] = useState([]);
  const [newFolderId, setNewFolderId] = useState([]);
  const [collaboratorCount, setCollaboratorCount] = useState('');
  const getData = useDashboardContext();
  const [skipValue, setSkipValue] = useState(0);
  const [nextCall, setNextCall] = useState(false);
  const [coteachers, setCoteachers] = useState([]);
  const [isCoteacherLoading, setIsCoteacherLoading] = useState(false);
  const [isCollaboratorLoading, setIsCollaboratorLoading] = useState(false);

  const {
    assignedData,
    setAssignedData,
    noOfAssignments,
    setNoOfAssignments,
    setAssignmentIdSend,
    setAssignmentId,
    assignmentId,
    assignedName,
    setAssignedName,
    assignedCourseName,
    setAssignedCourseName,
    assignmentName,
    setAssignmentName,
    setAssignmentAssignedViaDetails,
    setAssignedStatus,
    isAssignmentsAvailable,
    setNoOfAssignedStudents,
    setAssignedCount,
    setAssignmentCourseId
  } = useAssignmentContext();
  const limit = 30;
  const [isLoading, setIsLoading] = useState(false);
  const getAllAssignmentsByFilterAsync = async (skip, take) => {
    try {
      const options = {
        skip,
        take
      };
      if (assignmentSortValue != null) options.sort = assignmentSortValue;
      if (selectedAssignment.selectedStatusId === '' && selectedAssignment.search) {
        options.AssignmentStatus = [];
      } else {
        selectedAssignment.selectedStatusId.length != 0
          ? (options.AssignmentStatus = selectedAssignment.selectedStatusId)
          : (options.AssignmentStatus = filters.assignmentStatus);
      }

      if (selectedAssignment.selectedAssignedViaId === '' && selectedAssignment.search) {
        options.AssignedVia = [];
      } else {
        selectedAssignment.selectedAssignedViaId.length != 0
          ? (options.AssignedVia = selectedAssignment.selectedAssignedViaId)
          : (options.AssignedVia = filters.assignedVia);
      }
      if (
        selectedAssignment.selectedKeyWord !== undefined &&
        selectedAssignment.selectedKeyWord !== ''
      )
        options.SearchText = selectedAssignment.selectedKeyWord;
      options.CourseId =
        selectedAssignment.selectedCourseId !== undefined &&
          selectedAssignment.selectedCourseId !== ''
          ? selectedAssignment.selectedCourseId
          : filters.courseId === undefined
            ? -1
            : filters.courseId;
      options.FolderId =
        selectedAssignment.selectedFolderId !== undefined &&
          selectedAssignment.selectedFolderId !== ''
          ? selectedAssignment.selectedFolderId
          : filters.folderId === undefined
            ? -1
            : filters.folderId;
      options.IsSearch = selectedAssignment.search === false ? false : true;
      return await getAssignmentsByFilter(options).unwrap();
    } catch (error) {
      console.log(error);
    }
  };

  const validateSubmitAssignmentAsync = async (value, assignmentId) => {
    if (!isLoading) {
      setIsLoading(true);
      try {
        const options = {
          assignmentId: assignmentId
        };
        let url = baseUrl + '/Assignment/ValidateSubmitAssignment';
        url += '?assignmentId=' + options.assignmentId;
        const headers = {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        };
        const response = await fetch(url, { headers, method: 'GET' });
        const errorMsg = await response.text();
        const result = response.status;
        if (result === 200) {
          value.modal();
          setIsLoading(false);
        } else {
          CustomToast(`${errorMsg}`, 'warning');
          setIsLoading(false);
        }
      } catch (ex) {
        console.log(ex);
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    getFiltersAsync();
    selectedAssignment.setSelectedKeyWord('');
  }, []);

  useEffect(() => {
    if (filters.courseId != undefined && isAssignmentsAvailable) {
      if (selectedAssignment.search) {
        setAssignedData([]);
        setNewCourseId(selectedAssignment.selectedCourseId);
        setNewFolderId(selectedAssignment.selectedFolderId);
      }
      if (assignmentSortValue || selectedAssignment.search) {
        setNextCall(false);
        setLoadMoreData([]);
        setSkipValue(0);
      }

      loadInitialData();
    }
  }, [
    selectedAssignment.search,
    assignmentSortValue,
    selectedAssignment.assignedDataStatus,
    filters
  ]);

  const getFiltersAsync = async () => {
    try {
      const persistFilters = await getFilters().unwrap();
      const allPersistFilters = persistFilters;
      allPersistFilters !== null && allPersistFilters !== undefined
        ? setFilters(allPersistFilters)
        : setFilters([]);

      setNewCourseId(allPersistFilters.courseId);
      setNewFolderId(allPersistFilters.folderId);
    } catch (error) {
      console.log(error);
    }
  };
  const loadInitialData = async () => {
    setIsLoading(true);
    const { total, data } = await getAllAssignmentsByFilterAsync(0, 30);
    distinctObjects(data);
    setNoOfAssignments(total);
    setIsLoading(false);
  };

  const nextCallback = async (newOffset) => {
    setNextCall(true);
    setIsLoading(true);
    setSkipValue(newOffset);
    const { total, data } = await getAllAssignmentsByFilterAsync(newOffset, limit);
    let newItems = [...loadMoreData, ...data];
    distinctObjects(newItems);
    setNoOfAssignments(total);
    setIsLoading(false);
  };

  const distinctObjects = (data) => {
    var distinctData = Array.from(
      data.reduce((map, obj) => map.set(obj.assignmentId, obj), new Map()).values()
    );
    setLoadMoreData(distinctData);
  };
  const megaListDropdown = () => {
    const megaDropdown = [
      {
        id: 'viewChanges',
        name: 'View Assignment Changes',
        icon: <FontAwesomeIcon icon={faSitemap} />,
        link: 'manage_assign/reports/assignment_changes_report'
      },
      {
        id: 'printAssignment',
        name: 'Print Assignment/Key',
        icon: <FontAwesomeIcon icon={faPrint} />
      },
      {
        id: 'displayVocabulary',
        name: 'Display/Print Vocabulary',
        icon: <FontAwesomeIcon icon={faList} />,
        link: 'vocabularyPrinting'
      },
      {
        id: 'deleteAssignment',
        name: 'Delete Assignment',
        icon: <FontAwesomeIcon icon={faTrash} />,
        modal: () => setDeleteAssignmentsModal(!deleteAssignmentsModal)
      },
      {
        id: 'sendCopy',
        name: 'Send Copy',
        icon: <FontAwesomeIcon icon={faShare} />
      },
      {
        id: 'previewAssignment',
        name: 'Preview Assignment',
        icon: <FontAwesomeIcon icon={faPlay} />,
        modal: () => setPreviewAssignmentModal(!previewAssignmentModal)
      },
      {
        id: 'moveToFolder',
        name: 'Move to Folder',
        icon: <FontAwesomeIcon icon={faFolderPlus} />,
        modal: () => setMoveAssignmentsModal(!moveAssignmentsModal)
      },
      {
        id: 'exportToXML',
        name: 'Export to XML',
        icon: <FontAwesomeIcon icon={faFileArrowUp} />
      },
      {
        id: 'makePublic',
        name: 'Make Public',
        icon: <FontAwesomeIcon icon={faPaperPlane} />,
        modal: () => setPublishAssignmentsModal(!publishAssignmentsModal)
      },
      {
        id: 'submitAsBenchmark',
        name: 'Submit as Benchmark',
        icon: <FontAwesomeIcon icon={faClipboardCheck} />,
        modal: () => setSubmitAssignmentsModal(!submitAssignmentsModal)
      },
      {
        id: 'duplicate',
        name: 'Duplicate',
        icon: <FontAwesomeIcon icon={faPaste} />,
        modal: () => setDuplicateAssignmentsModal(!duplicateAssignmentsModal)
      },
      {
        id: 'collaborators',
        name: 'Assignment Collaborators',
        icon: <FontAwesomeIcon icon={faFilePen} />,
        modal: (assignmentId) => manageViewCollaborator(assignmentId)
      }
    ];
    setLoadMegaDropDown(megaDropdown);
  };

  const handleChange = (e) => {
    const { name, checked } = e.target;
    if (name === 'allselect') {
      let tempLoadMoreData = loadMoreData.map((item) => {
        return { ...item, isChecked: checked };
      });
      setLoadMoreData(tempLoadMoreData);
      setAssignedData(tempLoadMoreData);
    } else {
      const id = parseInt(name);
      let loadMoreDataArray = loadMoreData.map((item) =>
        item.assignmentId === id ? { ...item, isChecked: checked } : item
      );

      const selectedData = loadMoreData.find((item) => item.assignmentId === id);

      const assignmentNames = [];
      const courseNames = [];
      // assignmentNameArray
      if (assignedName.includes(selectedData.assignmentName)) {
        setAssignedName(assignedName.filter((item) => item !== selectedData.assignmentName));
      } else {
        assignmentNames.push(...assignedName, selectedData.assignmentName);
        setAssignedName(assignmentNames);
      }
      // courseNameArray
      if (assignedCourseName.includes(selectedData.courseName)) {
        setAssignedCourseName(
          assignedCourseName.filter((item) => item !== selectedData.courseName)
        );
      } else {
        courseNames.push(...assignedCourseName, selectedData.courseName);
        setAssignedCourseName(courseNames);
      }

      let assignedDataArray = [];
      if (
        assignedData.filter((item) => item.assignmentId === selectedData.assignmentId).length > 0
      ) {
        setAssignedData(
          assignedData.filter((item) => item.assignmentId !== selectedData.assignmentId)
        );
      } else {
        assignedDataArray.push(...assignedData, selectedData);
        setAssignedData(assignedDataArray);
      }
      setLoadMoreData(loadMoreDataArray);
    }
  };

  useEffect(() => {
    megaListDropdown();
  }, []);

  const assignmentSort = (e) => {
    let order = 0;
    let sortValue = '';
    const sortId = e.currentTarget.id;
    switch (sortId) {
    case 'sort-assignment':
      sortValue = 'Assignment';
      break;
    case 'sort-questions':
      sortValue = 'Questions';
      break;
    case 'sort-created':
      sortValue = 'Created Date';
      break;
    case 'sort-last-assigned':
      sortValue = 'Last Assigned Date';
      break;
    case 'sort-folder':
      sortValue = 'Folder Name';
      break;
    case 'sort-course':
      sortValue = 'Course Name';
      break;
    default:
      sortValue = 'Assignment';
    }
    setAssignmentSortOrder(!assignmentSortOrder);
    if (assignmentSortOrder && filters.sortColumn === sortValue)
      order = 1;

    setFilters(prevFilters => ({ ...prevFilters, sortColumn: sortValue, sortDirection: order === 1 ? 'DESC' : 'ASC' }));
    const sortdata = [sortValue, order];
    setAssignmentSortValue(sortdata);
  };

  const exportAssignmentMenu = async (id) => {
    try {
      const option = [id];
      await exportAssignment(option).unwrap();
    } catch (error) {
      if (error.data) {
        const XMLData = error.data;
        const blob = new Blob([XMLData], { type: 'text/xml' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        const fileName = 'CastleXMLAssignments.xml';
        link.download = fileName;
        link.href = url;
        link.click();
        URL.revokeObjectURL(url);
      }
    }
  };

  useEffect(() => {
    if (selectedAssignment.assignedViaUpdate) {
      const updatedArray = loadMoreData?.map((item1) => {
        const matchingItem2 = assignedData?.find(
          (item2) => item2.assignmentId === item1.assignmentId
        );
        if (matchingItem2) {
          return { ...item1, assignedVia: matchingItem2.assignedVia };
        }
        return item1;
      });
      setLoadMoreData(updatedArray);
      selectedAssignment.setAssignedViaUpdate(false);
    }
  }, [assignedData]);

  const getCollaboratorCount = async (assignmentId) => {
    if (assignmentId != null && assignmentId != undefined && assignmentId > 0) {
      const options = {
        assignmentId: assignmentId
      };
      try {
        setIsCollaboratorLoading(true);
        const result = await getCollaborator(options).unwrap();
        setCollaboratorCount(result);
        setIsCollaboratorLoading(false);
      } catch {
        CustomToast('Error while fetching Collaborator count', 'danger');
      }
    }
  };

  const handlePrintingOptions = (e) => {
    const id = e.currentTarget.id;
    const option = printOptions.map((item) =>
      item.id === id ? { ...item, isActive: true } : { ...item, isActive: false }
    );
    if (id === 'standardPrinting') {
      const url = `${assignmentId}/standardPrinting`;
      setNavigation(url);
    } else {
      const url = `${assignmentId}/answerKey`;
      setNavigation(url);
    }
    setPrintOptions(option);
  };

  const printingOptions = [
    {
      id: 'standardPrinting',
      icon: <FontAwesomeIcon icon={faPrint} className="printing-icon" />,
      label: 'Standard Assignment Printing'
    },
    {
      id: 'answerKey',
      icon: <FontAwesomeIcon icon={faKey} className="printing-icon" />,
      label: 'Answer Key'
    }
  ];
  const [printOptions, setPrintOptions] = useState(printingOptions);
  const [navigation, setNavigation] = useState('');
  const handlePrintAssignment = (assignmentId, assignmentName) => {
    setPrintingOptionsModal(!printingOptionsModal);
    setAssignmentId(assignmentId);
    setAssignmentName(assignmentName);
    setPrintOptions(printingOptions);
  };

  const handlePrintOptionContinue = () => {
    navigate(navigation, { state: { assignmentId: assignmentId, assignmentName: assignmentName } });
  };

  const navigate = useNavigate();

  const manageViewCollaborator = async (assignmentId) => {
    setViewCoTeachersModal(true);
    setIsCoteacherLoading(true);
    try {
      let paramIds = [assignmentId];
      const options = {
        assignmentIds: paramIds
      };
      const allCoTeachers = await getCoteachers(options).unwrap();
      allCoTeachers.length > 0 ?
        setCoteachers(allCoTeachers[0].coTeachers) :
        setCoteachers([]);
    } catch (error) {
      console.log(error);
    }
    setIsCoteacherLoading(false);
  };

  return (
    <>
      <InfiniteScroll
        dataLength={loadMoreData.length}
        next={() => nextCallback(skipValue + limit)}
        hasMore={(noOfAssignments / (skipValue + limit)) > 1}
        scrollableTarget='scrollableDiv'>
        <div  id='scrollableDiv' className='assignments-scroll-bar' style={{ overflowY: 'auto' }}>
          <table className="table">
            <thead>
              <tr>
                <th className='height-unset'>
                  <div className="form-check">
                  </div>
                </th>
                <th id='sort-assignment' className='height-unset cursor-pointer' onClick={(e) => assignmentSort(e)}>
                  Assignment Name{' '}
                  <button id="sort-assignment" className="assignment-sort-btn sort-btn row" onClick={(e) => assignmentSort(e)}>
                    <FontAwesomeIcon icon={faCaretUp} className={`${filters?.sortColumn === 'Assignment' && filters?.sortDirection === 'ASC' ? 'enabled-caret' : ''}`} />
                    <FontAwesomeIcon className={`align-caret-down ${filters?.sortColumn === 'Assignment' && filters?.sortDirection === 'DESC' ? 'enabled-caret' : ''}`} icon={faCaretDown} />
                  </button>
                </th>
                <th id='sort-questions' className="text-center p-0 height-unset cursor-pointer" onClick={(e) => assignmentSort(e)}>Questions </th>
                <th className='height-unset cursor-pointer'>
                  <button
                    className="assignment-sort-btn sort-btn row"
                    id="sort-questions"
                    onClick={(e) => assignmentSort(e)}
                  >
                    <FontAwesomeIcon icon={faCaretUp} className={`${filters?.sortColumn === 'Questions' && filters?.sortDirection === 'ASC' ? 'enabled-caret' : ''}`} />
                    <FontAwesomeIcon className={`align-caret-down ${filters?.sortColumn === 'Questions' && filters?.sortDirection === 'DESC' ? 'enabled-caret' : ''}`} icon={faCaretDown} />
                  </button>
                </th>
                <th id='sort-created' className="text-center p-0 height-unset cursor-pointer" onClick={(e) => assignmentSort(e)}>Created </th>
                <th className='height-unset cursor-pointer'>
                  <button
                    id="sort-created"
                    className="assignment-sort-btn sort-btn row"
                    onClick={(e) => assignmentSort(e)}
                  >
                    <FontAwesomeIcon icon={faCaretUp} className={`${filters?.sortColumn === 'Created Date' && filters?.sortDirection === 'ASC' ? 'enabled-caret' : ''}`} />
                    <FontAwesomeIcon className={`align-caret-down ${filters?.sortColumn === 'Created Date' && filters?.sortDirection === 'DESC' ? 'enabled-caret' : ''}`} icon={faCaretDown} />
                  </button>
                </th>
                <th id='sort-last-assigned' className="text-center p-0 height-unset cursor-pointer" onClick={(e) => assignmentSort(e)}>Last Assigned </th>
                <th className='height-unset cursor-pointer'>
                  <button
                    id="sort-last-assigned"
                    className="assignment-sort-btn sort-btn row"
                    onClick={(e) => assignmentSort(e)}
                  >
                    <FontAwesomeIcon icon={faCaretUp} className={`${filters?.sortColumn === 'Last Assigned Date' && filters?.sortDirection === 'ASC' ? 'enabled-caret' : ''}`} />
                    <FontAwesomeIcon className={`align-caret-down ${filters?.sortColumn === 'Last Assigned Date' && filters?.sortDirection === 'DESC' ? 'enabled-caret' : ''}`} icon={faCaretDown} />
                  </button>
                </th>
                <th className='height-unset'>Completed</th>
                {newFolderId === -1 && (
                  <th id='sort-folder' className='height-unset cursor-pointer' onClick={(e) => assignmentSort(e)}>
                    Folder{' '}
                    <button id="sort-folder" className="assignment-sort-btn sort-btn row" onClick={(e) => assignmentSort(e)}>
                      <FontAwesomeIcon icon={faCaretUp} className={`${filters?.sortColumn === 'Folder Name' && filters?.sortDirection === 'ASC' ? 'enabled-caret' : ''}`} />
                      <FontAwesomeIcon className={`align-caret-down ${filters?.sortColumn === 'Folder Name' && filters?.sortDirection === 'DESC' ? 'enabled-caret' : ''}`} icon={faCaretDown} />
                    </button>
                  </th>
                )}
                {newCourseId === -1 && (
                  <th id='sort-course' className='height-unset cursor-pointer' onClick={(e) => assignmentSort(e)}>
                    Course{' '}
                    <button id="sort-course" className="assignment-sort-btn sort-btn row" onClick={(e) => assignmentSort(e)}>
                      <FontAwesomeIcon icon={faCaretUp} className={`${filters?.sortColumn === 'Course Name' && filters?.sortDirection === 'ASC' ? 'enabled-caret' : ''}`} />
                      <FontAwesomeIcon className={`align-caret-down ${filters?.sortColumn === 'Course Name' && filters?.sortDirection === 'DESC' ? 'enabled-caret' : ''}`} icon={faCaretDown} />
                    </button>
                  </th>
                )}
                <th className='height-unset'>Assigned Via</th>
                <th className='height-unset'></th>
              </tr>
            </thead>
            <tbody id="list-body">
              {isLoading && nextCall && (
                <tr>
                  <td colSpan={13}>
                    <div className='scroll-spinner mt-3 d-flex align-item-center justify-content-center'>
                      <FontAwesomeIcon icon={faSpinner} spin /><span className='ms-2'>Load More</span>
                    </div>
                  </td>
                </tr>
              )}
              {loadMoreData.map((item, index) => {
                let createdDate = new Intl.DateTimeFormat('en-US', {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit'
                })
                  .format(new Date(item.createdDate))
                  .split('/')
                  .join('-');
                let lastAssignedDate = item.lastAssignedDate !== null ? new Intl.DateTimeFormat('en-US', {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit'
                })
                  .format(new Date(item.lastAssignedDate))
                  .split('/')
                  .join('-') : '';
                let percentage = 0;
                let assignedViaImg = '';
                let tooltipContent = '';
                if (item.assignedCount != 0) {
                  percentage = ((item.completedCount / item.assignedCount) * 100).toFixed(0);
                }
                switch (item.assignedStatus) {
                case 1:
                  assign = 'badge assigned';
                  assignText = 'Assigned';
                  assignTooltip = 'Assigned/Accessible to all assigned students';
                  break;
                case 2:
                  assign = 'badge no-access';
                  assignText = 'Not Accessible';
                  assignTooltip = 'Assigned/Not accessible to any assigned students';
                  break;
                case 3:
                  assign = 'badge partial';
                  assignText = 'Partially Assigned';
                  assignTooltip = 'Assigned/Accessible to some assigned students';
                  break;
                case 4:
                  assign = 'badge random';
                  assignText = 'Not Assigned';
                  assignTooltip = 'Not Assigned to any students';
                  break;
                default:
                  assign = 'badge random';
                  assignText = 'Not Assigned';
                  break;
                }
                if (percentage <= 25) {
                  circlePathColor = '#f84646';
                } else if (percentage <= 50) {
                  circlePathColor = '#ffa800';
                } else if (percentage <= 75) {
                  circlePathColor = '#3e98c7';
                } else {
                  circlePathColor = '#52c9a5';
                }
                switch (item.assignedVia) {
                case 1:
                  assignedViaImg = assignedVia_1;
                  tooltipContent = 'Castle';
                  break;
                case 2:
                  assignedViaImg = assignedVia_2;
                  tooltipContent = 'Google Classroom';
                  break;
                case 3:
                  assignedViaImg = assignedVia_3;
                  tooltipContent = 'Schoology';
                  break;
                case 4:
                  assignedViaImg = assignedVia_4;
                  tooltipContent = 'Canvas';
                  break;
                }
                return (
                  <tr key={`${item.assignmentId}-assignment-list-${index}`}>
                    <td>
                      <div className="form-check">
                        <input
                          type="checkbox"
                          value=""
                          name={item.assignmentId}
                          checked={item?.isChecked || false}
                          onChange={handleChange}
                          className="form-check-input"
                          id={`flexCheckDefault${item.assignmentId}`}
                        />
                      </div>
                    </td>
                    <td>
                      {item.assignmentName}
                      {item.ownerName.length > 0 && (
                        <div>
                          <span className="text-danger fs-7"> {item.ownerName}</span>
                        </div>
                      )}
                      {(item.locked.length > 0 || item.benchmarkName.length > 0) && (
                        <div className="locked-data d-flex">
                          {item.locked.length > 0 && <span className='mr-1'><FontAwesomeIcon icon={faLock} /></span>}
                          <span>{item.locked} {item.benchmarkName.length > 0 ? 'Benchmark - ' + item.benchmarkName : ''} </span>
                        </div>
                      )}
                      <div className="d-block mt-1">
                        <ReactTooltip
                          id={`status-${index}`}
                          place="top"
                          content={assignTooltip}
                          className="list-tooltip"
                        />
                        <span data-tooltip-id={`status-${index}`} className={`${assign} p-1`}>
                          {assignText}
                        </span>
                      </div>
                    </td>
                    <td className="text-center">{item.noOfQuestion}</td>
                    <td></td>
                    <td className="text-center">{createdDate}</td>
                    <td></td>
                    <td className="text-center">{lastAssignedDate}</td>
                    <td></td>
                    <td>
                      <div className="d-flex align-items-center gap-3">
                        <CircularProgressbar
                          value={percentage}
                          text={`${percentage}%`}
                          strokeWidth={12}
                          styles={buildStyles({
                            pathColor: `${circlePathColor}`,
                            textColor: '#525252',
                            trailColor: '#d6d6d6'
                          })}
                        />
                        {item.completedCount}/{item.assignedCount}
                      </div>
                    </td>
                    {newFolderId === -1 && <td>{item.folderName}</td>}
                    {newCourseId === -1 && <td>{item.courseName}</td>}
                    <td className="text-center">
                      <ReactTooltip
                        id={`icon-${index}`}
                        place="top"
                        content={tooltipContent}
                        className="list-tooltip z-index10"
                      />
                      <img
                        src={assignedViaImg}
                        className="img-fluid"
                        data-tooltip-id={`icon-${index}`}
                      />
                    </td>
                    <td>
                      <div className="action-btns d-flex justify-content-end gap-2">
                        <NavLink
                          onClick={() => {
                            setAssignmentId(item.assignmentId);
                            setAssignmentName(item.assignmentName);
                            setAssignedCourseName([item.courseName]);
                            setAssignmentAssignedViaDetails({ id: item.assignedVia });
                            setAssignedStatus(item.assignedStatus);
                            setNoOfAssignedStudents(item.assignedCount);
                          }}
                          end
                          to={`${item.assignmentId}/manage_assign`}>
                          <ReactTooltip
                            id={`manage-${index}`}
                            place="top"
                            content="Manage/Assign"
                            className="list-tooltip z-index10"
                          />
                          <button id={`manage${item.assignmentId}`} data-tooltip-id={`manage-${index}`}>
                            <FontAwesomeIcon icon={faUserCheck} />
                          </button>
                        </NavLink>
                        <NavLink
                          end
                          to={`${item.assignmentId}/edit_assignment`}
                          onClick={() => {
                            setAssignmentId(item.assignmentId);
                            setAssignmentName(item.assignmentName);
                            setAssignmentCourseId(item.courseId);
                            setAssignmentAssignedViaDetails({ id: item.assignedVia });
                          }}
                          state={{ assignedStatus: item.assignedStatus, mcChoices: selectedAssignment.mcChoices, assignedViaDetails: { id: item.assignedVia } }}>
                          <ReactTooltip
                            id={`view-${index}`}
                            place="top"
                            content="View/Edit Assignment"
                            className="list-tooltip z-index10"
                          />
                          <button
                            id={`edit-${item.assignmentId}`}
                            style={{ disabled: 'disabled' }}
                            data-tooltip-id={`view-${index}`}>
                            <FontAwesomeIcon icon={faPenToSquare} />
                          </button>
                        </NavLink>
                        <div className="position-relative">
                          <ReactTooltip
                            id={`moreactions-${index}`}
                            place="top"
                            content="More Actions"
                            className="list-tooltip z-index10"
                          />
                          <Dropdown
                            onClick={() => {
                              getCollaboratorCount(item.assignmentId), setCollaboratorCount(0);
                            }}
                            data-tooltip-id={`moreactions-${index}`}>
                            <Dropdown.Toggle>
                              <FontAwesomeIcon icon={faEllipsis} />
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="more-dropdown">
                              {loadMegaDropDown.map((val, arrayKey) => {
                                if (val.id === 'viewChanges' || val.id === 'displayVocabulary') {
                                  return (
                                    <Dropdown.Item
                                      key={`drop-${arrayKey}`}
                                      as={Link}
                                      to={`${item.assignmentId}/${val.link}`}
                                      state={{
                                        assignmentName: item.assignmentName,
                                        assignmentId: item.assignmentId
                                      }}>
                                      {val.icon}
                                      {val.name}
                                    </Dropdown.Item>
                                  );
                                } else if (val.id === 'printAssignment') {
                                  return (
                                    <Dropdown.Item
                                      key={`drop-${arrayKey}`}
                                      onClick={() => handlePrintAssignment(item.assignmentId, item.assignmentName)}>
                                      {val.icon}
                                      {val.name}
                                    </Dropdown.Item>
                                  );
                                } else if (val.id === 'exportToXML') {
                                  return (
                                    <Dropdown.Item
                                      key={`drop-${arrayKey}`}
                                      onClick={() => exportAssignmentMenu(item.assignmentId)}>
                                      {val.icon}
                                      {val.name}
                                    </Dropdown.Item>
                                  );
                                } else if (val.id === 'sendCopy') {
                                  return (
                                    <Dropdown.Item
                                      key={`drop-${arrayKey}`}
                                      onClick={() => {
                                        getData.setSelectRecipient(true);
                                        setAssignmentIdSend([item.assignmentId]);
                                        setAssignmentName(item.assignmentName);
                                      }}>
                                      {val.icon}
                                      {val.name}
                                    </Dropdown.Item>
                                  );
                                } else if (val.id === 'makePublic') {
                                  return (
                                    <Dropdown.Item
                                      key={`drop-${arrayKey}`}
                                      onClick={() => {
                                        validateSubmitAssignmentAsync(val, item.assignmentId);
                                        setAssignmentId(item.assignmentId);
                                        setAssignmentName(item.assignmentName);
                                        setAssignedName([item.assignmentName]);
                                        setAssignedCourseName([item.courseName]);
                                        setAssignmentAssignedViaDetails({ id: item.assignedVia });
                                      }}
                                      disabled={isLoading}>
                                      {val.icon}
                                      {val.name}
                                    </Dropdown.Item>
                                  );
                                } else if (val.id === 'submitAsBenchmark') {
                                  return (
                                    <Dropdown.Item
                                      key={`drop-${arrayKey}`}
                                      onClick={() => {
                                        validateSubmitAssignmentAsync(val, item.assignmentId);
                                        setAssignmentId(item.assignmentId);
                                        setAssignmentName(item.assignmentName);
                                        setAssignedName([item.assignmentName]);
                                        setAssignedCourseName([item.courseName]);
                                        setAssignmentAssignedViaDetails({ id: item.assignedVia });
                                      }}
                                      disabled={isLoading}>
                                      {val.icon}
                                      {val.name}
                                    </Dropdown.Item>
                                  );
                                } else if (val.id === 'collaborators') {
                                  return (
                                    <>
                                      {!isCollaboratorLoading ? 
                                        ( 
                                          <Dropdown.Item
                                            className="d-flex"
                                            key={`drop-${arrayKey}`}
                                            onClick={() => {
                                              setAssignmentId(item.assignmentId);
                                              val.modal(item.assignmentId);
                                            }}
                                            disabled={false}>
                                            {val.icon}
                                            {val.name}
                                            {collaboratorCount > 0 ? (
                                              <div className="collaborator-count mx-1">
                                                <span>{collaboratorCount}</span>
                                              </div>
                                            ) : (
                                              ''
                                            )}
                                          </Dropdown.Item>
                                        ):
                                        (
                                          <Dropdown.Item
                                            key={`drop-${arrayKey}`}>
                                            <Skeleton/>
                                          </Dropdown.Item>
                                        )}
                                    </>
                                  );
                                } else {
                                  return (
                                    <Dropdown.Item
                                      key={`drop-${arrayKey}`}
                                      onClick={() => {
                                        val.modal();
                                        setAssignedCount(item.assignedCount);
                                        setAssignmentId(item.assignmentId);
                                        setAssignmentName(item.assignmentName);
                                        setAssignedName([item.assignmentName]);
                                        setAssignedCourseName([item.courseName]);
                                        setAssignmentAssignedViaDetails({ id: item.assignedVia });
                                      }}>
                                      {val.icon}
                                      {val.name}
                                    </Dropdown.Item>
                                  );
                                }
                              })}
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </InfiniteScroll>
      {isLoading && (
        <div className='mt-3 text-center fs-4'>
          <FontAwesomeIcon icon={faSpinner} spin /><span className='ms-2'></span>
        </div>
      )}
      
      {viewCoTeachersModal && (
        <ViewCoTeachersModal
          modalData={viewCoTeachersModal}
          onClose={() => setViewCoTeachersModal(false)}
          setModalData={setViewCoTeachersModal}
          fromMoreActions={true}
          coteachers={coteachers}
          setCoteachers={setCoteachers}
          coTeachersDataLoading={isCoteacherLoading}
        />
      )}

      <OptionTileModal
        isOpen={printingOptionsModal}
        onClose={() => setPrintingOptionsModal(false)}
        title={'Select Print Option'}
        options={printOptions}
        handleOptionClick={handlePrintingOptions}
        saveLabel={'Continue'}
        handleSaveClick={handlePrintOptionContinue}
      />
      {moveAssignmentsModal && (
        <MoveMenuModal
          modalData={moveAssignmentsModal}
          setModalData={setMoveAssignmentsModal}
          fromMoreActions={true}
        />
      )}

      <PublishMenuModal
        modalData={publishAssignmentsModal}
        setModalData={setPublishAssignmentsModal}
        fromMoreActions={true}
      />
      <ShareMenuModal
        assignmentId={selectedAssignment?.assignedData?.map((item) => item.assignmentId)}
      />
      <SubmitMenuModal
        modalData={submitAssignmentsModal}
        setModalData={setSubmitAssignmentsModal}
        fromMoreActions={true}
      />
      <DuplicateMenuModal
        modalData={duplicateAssignmentsModal}
        setModalData={setDuplicateAssignmentsModal}
        fromMoreActions={true}
      />
      {deleteAssignmentsModal && (
        <DeleteMenuModal
          modalData={deleteAssignmentsModal}
          setModalData={setDeleteAssignmentsModal}
          fromMoreActions={true}
        />
      )}
      {/* preview modal */}
      <AssignMenuPreviewModal
        modalData={previewAssignmentModal}
        setModalData={setPreviewAssignmentModal}
      />
    </>
  );
};

export default CurrentAssignmentsList;
